import PropTypes from 'prop-types';
import React from 'react';

export default class extends React.Component {
    static displayName = 'PencilSvg';

    static propTypes = {
        pathClassName: PropTypes.string
    };

    render() {
        const { pathClassName } = this.props;
        return (
            <svg width="13px" height="13px" viewBox="0 0 13 13" >
                <path d="M12.717601,2.00150943 L10.951101,0.268339623 C10.775351,0.0956603774 10.540851,0 10.291851,0 C10.042851,0 9.80935104,0.0949245283 9.63260104,0.267358491 L0.857351043,8.87801887 C0.760601043,8.9584717 0.687351043,9.06688679 0.658101043,9.19811321 L0.0146010429,12.028434 C-0.0303989571,12.2258868 0.0301010429,12.4306981 0.175601043,12.5736981 C0.288851043,12.6848113 0.442351043,12.7461321 0.599351043,12.7461321 C0.643351043,12.7461321 0.687351043,12.7412264 0.730351043,12.7316604 L3.61610104,12.1003019 C3.74985104,12.0706226 3.86110104,11.9987547 3.94310104,11.9028491 L12.717601,3.29390566 C13.080851,2.93750943 13.080851,2.35790566 12.717601,2.00150943 L12.717601,2.00150943 Z M8.53410104,3.01035849 L9.92185104,4.37192453 L4.51835104,9.67420755 L3.13060104,8.31264151 L8.53410104,3.01035849 Z M1.78885104,9.62833962 L2.28210104,9.14537736 L3.66985104,10.5069434 L3.17660104,10.9896604 L1.39135104,11.3806415 L1.78885104,9.62833962 Z M10.770351,3.53918868 L9.38260104,2.17786792 L10.291851,1.28675472 L11.679601,2.64832075 L10.770351,3.53918868 Z" />
                <path className={pathClassName} d="M6,12.5 L12.5,12.5" strokeLinecap="round" />
            </svg>
        );
    }
}